import React from 'react'
import PropTypes from 'prop-types'
import {TextInput} from '@/components/atoms'
import styles from '../RewardSetup.module.scss'
import {useAppSelector} from '@/store'
import {getCurrencySymbol} from '@/utils/commons'
import { preventInvalidNumericInput } from '@/utils/inputValidations'
/**
 * DigitalCondition component displays the bonus products reward condition UI
 * Handles product selection via modal triggered by dropdown option selection, order quantity, and bonus product limit inputs
 *
 * @param {Object} props - Component props
 * @param {Object} props.formData - Form data containing digitalValue, digitalSupplier, digitalPoints
 * @param {Function} props.handleDigitalValueChange - Handler for digital value amount
 * @param {Function} props.handleDigitalSupplierChange - Handler for supplier text
 * @param {Function} props.handleDigitalPointsChange - Handler for digital points
 * @param {string} props.digitalValueError - Error message for value validation
 * @param {string} props.digitalSupplierError - Error message for supplier validation
 * @param {string} props.digitalPointsError - Error message for points validation
 * @returns {JSX.Element} The rendered DigitalCondition component
 */
const DigitalCondition = ({
  formData,
  handleDigitalValueChange,
  handleDigitalSupplierChange,
  handleDigitalPointsChange,
  digitalValueError,
  digitalSupplierError,
  digitalPointsError,
}) => {

const countryCode = useAppSelector(state => state.countryCode).countryCode
  const currencySymbol = getCurrencySymbol(countryCode)
  return (
    <div className="flex flex-wrap gap-[13px]">

      <span className="text-sm whitespace-nowrap mt-2">{currencySymbol}</span>
      <div className={`w-32 ${styles.rewardSetup__inputPoints}`}>
        <TextInput
          className='placeholder:text-sm text-sm'
          value={formData.digitalValue}
          onChange={handleDigitalValueChange}
          label=""
          placeholderText="Value"
          handleKeyDown={preventInvalidNumericInput}
          error={digitalValueError}
          isDark={true}
          type="number"
          id="reward-cash-amount"
        />
      </div>
      <span className="text-sm whitespace-nowrap mt-2">from</span>
      <div className={`w-44 ${styles.rewardSetup__inputPoints}`}>
        <TextInput
          className='placeholder:text-sm text-sm'
          value={formData.digitalSupplier}
          onChange={handleDigitalSupplierChange}
          label=""
          placeholderText="Supplier"
          error={digitalSupplierError}
          isDark={true}
          type="text"
          id="digital-supplier"
        />
      </div>
      <span className="text-sm whitespace-nowrap mt-2">by redeeming</span>
      <div className={`w-32 ${styles.rewardSetup__inputPoints}`}>
        <TextInput
          className='placeholder:text-sm text-sm'
          value={formData.digitalPoints}
          onChange={handleDigitalPointsChange}
          label=""
          placeholderText="Points"
          handleKeyDown={preventInvalidNumericInput}
          error={digitalPointsError}
          isDark={true}
          type="number"
          id="redeem-points"
        />
      </div>
      <span className="text-sm whitespace-nowrap mt-2">points.</span>
    </div>
  )
}

DigitalCondition.propTypes = {
  formData: PropTypes.shape({
    digitalValue: PropTypes.string,
    digitalSupplier: PropTypes.string,
    digitalPoints: PropTypes.string,
  }).isRequired,
  handleDigitalValueChange: PropTypes.func.isRequired,
  handleDigitalSupplierChange: PropTypes.func.isRequired,
  handleDigitalPointsChange: PropTypes.func.isRequired,
  digitalValueError: PropTypes.string,
  digitalSupplierError: PropTypes.string,
  digitalPointsError: PropTypes.string,
}

export default DigitalCondition

